export class OptionType {
  value: string;
  description: string;

  // only for surcharges
  checked: boolean;
}
